<template>
  <div class="tw-shadow-sm tw-rounded-md">
    <div class="tw-bg-primary-grey-25 tw-p-2 tw-rounded-t-md">
      <label
        class="tw-flex tw-items-center tw-gap-4 hover:tw-cursor-pointer tw-font-semibold"
        :for="type"
      >
        <cl-input-checkbox
          :id="type"
          :checked="allChecked"
          :indeterminate="someChecked"
          @change="toggleAll"
        />
        <div class="tw-flex tw-gap-2 tw-items-center">
          <div :class="[' tw-h-2 tw-w-2 tw-rounded-full', bgClass]"></div>
          <div>{{ $t(label) }}</div>
        </div>
      </label>
    </div>
    <ul class="tw-p-2 tw-flex tw-gap-4 tw-flex-wrap">
      <li v-for="checkbox in checkboxes" :key="checkbox.key">
        <label
          class="tw-flex tw-items-center tw-gap-4 hover:tw-cursor-pointer"
          :for="checkbox.key"
        >
          <cl-input-checkbox
            :id="checkbox.key"
            :checked="checkbox.checked"
            :indeterminate="false"
            @change="emit('update:checkbox', checkbox.key, !checkbox.checked)"
          />
          <div class="tw-flex tw-items-center tw-gap-2">
            {{ $t(checkbox.label) }}
            <span
              v-tippy="{
                content: $t(bypassCheckConfig[checkbox.key].info),
                placement: 'top',
              }"
              class="tw-flex tw-items-center tw-text-primary-grey-200"
            >
              <cb-icon-information :width="18" />
            </span>
          </div>
        </label>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { bypassCheckConfig, categoryColors } from "./bypass-check.config";
import { BypassCheck } from "../exemptions.types";

type Checkbox = {
  key: BypassCheck;
  label: string;
  checked: boolean;
};

const props = defineProps<{
  checkboxes: Checkbox[];
  type: "authentication" | "suspicious" | "malicious";
}>();

const label = computed(
  () =>
    ({
      authentication: "sender-authentication",
      suspicious: "suspicious",
      malicious: "malicious",
    })[props.type],
);

const bgClass = computed(() => categoryColors[props.type].indicatorClass);

const emit = defineEmits<{
  "update:checkbox": [key: string, value: boolean];
  "update:all": [value: boolean];
}>();

const allChecked = computed(() => props.checkboxes.every((cb) => cb.checked));
const someChecked = computed(
  () => props.checkboxes.some((cb) => cb.checked) && !allChecked.value,
);

const toggleAll = () => {
  emit("update:all", !allChecked.value);
};
</script>
